import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ProcedureTypeForm from '../Forms/ProcedureTypeForm';

const AddEditProcedureTypeModal = ({
	dataProcedureType,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Tipo de Trámite
			</ModalHeader>

			<ProcedureTypeForm
				dataProcedureType={dataProcedureType}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditProcedureTypeModal;
